<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWmat</div>
      </div>

      <img class="pwmat-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-introduce-container">

     <div class="pwmat-introduce-content">
       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">软硬一体化方案</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">龙讯旷腾除了提供PWmat软件授权，还提供预装龙讯旷腾各种软件产品的一体机，提供软硬结合的一体化方案，其中包括单机版Mstation和集群版Mcluster。
          无论是单机版Mstation还是集群版Mcluster，均配置好PWmat、Q-Flow、Q-Studio、PWkit，以及机器管理和作业调度软件，用户可开箱即用。同时，龙讯旷腾自建了超算云Mcloud，提供机时租赁服务，用户直接租机时即
          使用龙讯的各种软件产品。                                              
         </p>
       </div>
       
       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">单机版Mstation</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">单机版Mstation为双路4U服务器，包含两颗CPU（14x2=28核心）和4块GPU卡，同时预装PWmat、Q-Flow、Q-Studio和PWkit软件，也可以根据用户需求安装各种开源软件。
          两台单机版Mstation可以通过直接ib网线互联组成轻量化的集群，相比集群版Mcluster，其不需要管理节点及inifiniband交换机等设备，具有高性价比的特点，而且可以进行大体系计算。                                              
         </p>
         
       <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-left-img-png" src="../../assets/produce/mstation/mstation-product.jpg">
         <img class="mstation-introduce-content-right-img-png" src="../../assets/home/product_3.png">
       </div>


       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">下面的表格展示了Mstation和双机互联版的Mstation的硬件配置</p>

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">硬件</th>
             <th class="mstation-introduce-text-th">单机版Mstation</th>
             <th class="mstation-introduce-text-th">双机互联版Mstation</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU</td>
             <td class="mstation-introduce-text-td">两颗CPU (14x2=28核心)</td>
             <td class="mstation-introduce-text-td">每台机器两颗CPU（14x2x2=56）</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">GPU</td>
             <td class="mstation-introduce-text-td">4块NVIDIA ® GTX 3080Ti/3090</td>
             <td class="mstation-introduce-text-td">8块NVIDIA ® GTX 3080Ti/3090</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">内存</td>
             <td class="mstation-introduce-text-td">最大512GB DDR4</td>
             <td class="mstation-introduce-text-td">最大512GB DDR4</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">操作系统</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">IB交换网络</td>
             <td class="mstation-introduce-text-td"></td>
             <td class="mstation-introduce-text-td">有</td>
           </tr>
         </table>
       </div>
       </div>
       
       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">集群版Mcluster</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">MCluster由多台MStation、存储服务器以及一个管理节点组成，每台MStation之间通过超高速Infiniband网络进行数据传输。
          Mcloud同样预装PWmat、Q-Flow、Q-Studio和PWkit软件，同时也安装了集群管理软件XCAT,作业调度软件slurm等。部署PWmat后的“MCluster”在材料计算领域用途广泛，最典型的一
          个应用就是材料基因组计算，对于材料基因组开发，高通量计算、数据库建设、材料搜索都有极大的助益。目前最成功的案例就是北京大学深圳研究生院通过MCluster平台产生的材料数据库。
          在龙讯的帮助下，北大深圳研究生院建立了世界上首个HSE（杂化泛函）材料能带数据库。通过MCluster平台，每周能够为数据库产生超过一千个晶体结构的数据。MCluster+PWmat平台加上
          相对应的自动化工作流框架, 使这一套系统成为完成材料基因组项目的不可多得的有力工具。                                              
         </p>

       <div class="mcluster-introduce-content-img">
         <img class="mcluster-introduce-content-img-png" style="margin-top: 0;vertical-align: top;display: inline-block;margin-right: 50px" src="../../assets/produce/mcluster/mcluster_product.jpg">
       </div>

         <p class="pwmat-introduce-content-info-text2">MCluster另外方面的应用为超大体系的第一性原理计算。我们发现使用48个GPU能够计算高达5000个原子（20000个电子以上）的体系，
          其中一个典型的例子就是5120个Si原子的体系。在“MCluster”上，这样一个体系自洽计算足够收敛，仅仅需要3个小时。为了证明PWmat对大体系计算的准确性，我们计算了一个带点缺陷的4096
          Si原子的体材料体系 （见图），计算了该缺陷体系中费米面附近部分占据态（open shell）上电子的波函数，如下图2所示。另外我们也对1000个水分子（3000个原子，见图）的体系进行了
          第一性原理的分子动力学模拟：每一步分子动力学仅需要2.5分钟。这样的速度十分令人鼓舞，它已经接近原子基组方法的模拟规模和速度，但却不必担心可能由于基组不准而带来的误差。
          上面的例子是至今为止最大的平面波系统计算之一。比如2011年Gordon Bell prize, 计算了一个10,000 个Si原子的量子线，用了实空间方法，用的n1,n2,n3 要比我们5000 Si 原子的n1,n2,n3 小八倍，
           在当时世界最大的日本超级计算机“京””上计算，做一个自洽计算还需要24 小时。又比如，2006年的Gordon Bell prize，用平面波程序Qbox计算了一个1000 原子molybdenum的系统，
           总共有12,000 电子，用了整个BlueGene/L机器(当时世界上最快的计算机， 65,536 nodes）， 每一步自洽计算大致需要220秒 （按每一步SCF自洽由4步steepest decent steps 组成来估计）。
           相反，我们的Mcluster+PWmat, 计算一个3000 原子的Si 系统， 也是12,000 电子，每一步自洽计算只需要100秒 。 对于现有的开源和商业平面波基组模拟计算软件， 
           要完成这样的超大体系计算也并不容易，甚至无法实现。例如在众所周知的广州超算“天河二号”上，通过对公认最强的商业平面波计算软件进行反复测试，我们发现无论使用多少核（最大到几千核），
           4000个Si原子的体系始终无法运行，最多只能运行2000到3000个Si原子。使用2000个CPU来计算这个2000 个Si原子系统，使用默认的设置，此软件需要至少半个小时才能完成整个自洽计算。
           但同样的系统和任务，在MCluster+PWmat上来计算，总共只需要8分钟。具体测试数据详见下面表格：                                              
         </p>
         
         <div class="mcluster-introduce-content-info">
         <table class="mcluster-introduce-table">
           <tr class="mcluster-introduce-th">
             <th class="mcluster-introduce-text-th">测试体系</th>
             <th class="mcluster-introduce-text-th">原子数</th>
             <th class="mcluster-introduce-text-th">电子数</th>
             <th class="mcluster-introduce-text-th">截断能(eV)</th>
             <th class="mcluster-introduce-text-th">赝势</th>
             <th class="mcluster-introduce-text-th">时间（充分收敛）</th>
           </tr>
           <tr class="mcluster-introduce-td" v-for="param in mclustertParams" :key="param">
             <td class="mcluster-introduce-text-td">{{param.testSystem}}</td>
             <td class="mcluster-introduce-text-td">{{param.atomicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.electronicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.truncationCan}}</td>
             <td class="mcluster-introduce-text-td">{{param.turns}}</td>
             <td class="mcluster-introduce-text-td">{{param.time}}</td>
           </tr>
         </table>
       </div>
       </div>

     </div>

     <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">超算云Mcloud</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">Mcloud是由龙讯旷腾搭建的高性能集群和云桌面组成的超算云平台，2.0版本已于2022年4月1日成功上线，云平台集成了PWmat、Q-Flow、Q-Studio以及Lammps等软件，提供SaaS材料模拟计算服务，用户
可以自主完成注册，注册之后即可在线使用PWmat等软件和丰富GPU卡时资源。Q-Flow是龙讯旷腾推出PWmat可视化操作界面，将第一性原理计算图形化，把PWmat的功能模块分解为不同计算单元，用户通过过拽这些计算单元，连接成为工作流，即可完成不同性质计算。
Q-Studio是基于jsmol开发的在线建模工具，用户无需要安装任何软件，只需要打开浏览器就可以完成在线建模。Mcloud注册及登陆地址为：<a href="https://mcloud.lonxun.com" target="_blank">https://mcloud.lonxun.com</a>                                               
         </p>
       </div>


     </div>
    </div>
</template>

<script>
  import {PWMAT_RESOURCE} from '../../helpers/consts'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        PWMAT_RESOURCE,
      }
    },
    methods:{
      toMSTATIONDownload(){
        this.$router.push({ name: 'MSTATIONDownload'})
      },
      toPotentialDownload(){
        this.$router.push({ name: 'PotentialDownload'})
      },
      toModuleDownload(){
        this.$router.push({ name: 'ModuleDownload'})
      },
      toQuikStart(){
        this.$router.push({ name: 'QuickStartTutorial'})
      },
      toTutorials(){
        this.$router.push({ name: 'Tutorials'})
      },
      toCase(){
        this.$router.push({ name: 'Case'})
      },
      toTrain(){
        this.$router.push({ name: 'Train'})
      },
      toManual(){
        window.open(this.PWMAT_RESOURCE+'Manual.pdf')
      },
      tocnManual(){
        window.open(this.PWMAT_RESOURCE+'Manual_cn.pdf')
      },
      toProchureBook(){
        window.open(this.PWMAT_RESOURCE+'prochure.pdf')
      },
      toProchureNewFunctions(){
        window.open(this.PWMAT_RESOURCE+'PWmat_2019_new_functions.pdf')
      }

    }
  }
</script>

<script>
  import {MCLUSTERTable} from '../../helpers/productParam'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        mclustertParams:''
      }
    },
    created(){
      this.mclustertParams = MCLUSTERTable
    },
  }
</script>

<style scoped>
  .pwmat-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-introduce-background{
    margin-top: 70px;
  }
  .pwmat-introduce-banner{
    overflow:hidden;
  }
  .pwmat-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-introduce-content-title{
    padding-top: 50px;
  }
  .pwmat-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-introduce-content-info{
    margin-top: 30px;
    text-align: justify;
  }
  .pwmat-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-introduce-content-info-text2{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:30px;
  }
  .pwamt-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .pwmat-introduce-function{
    display: inline-block;
    padding-left: 80px;
    margin-bottom: 50px;
    width: 346px;
  }
  .pwmat-introduce-function-img{
    display: inline-block;
    vertical-align: top;
  }
  .pwmat-introduce-function-text{
    display: inline-block;
    vertical-align: top;
    margin-left: 23px;
  }
  .pwmat-introduce-function-name{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
    margin-top: -6px;
  }
  .pwmat-introduce-function-desc{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:20px;
  }
  .pwmat-inroduce-application{
    background:rgba(73,145,201,0.1);
    padding: 24px 99px 27px 99px;
    margin-bottom: 50px;
  }
  .pwmat-inroduce-application-group-1{
    width:539px;
    display: inline-block;
  }
  .pwmat-inroduce-application-group-2{
    width:299px;
    display: inline-block;
  }
  .pwmat-inroduce-application-text{
    font-size:16px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:38px;
    margin-bottom: 0;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-left-img-png{
    margin-top: 50px;
    margin-right: 180px;
    width: 300px;
  }
  .mstation-introduce-content-right-img-png{
    margin-top: 50px;
    width: 400px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:17px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:17px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .mcluster-introduce-content-img{
    text-align: center;
  }
  .mcluster-introduce-content-img-png{
    margin-top: 50px;
    width: 300px;
  }
  .mcluster-introduce-content-info{
    margin-top: 40px;
  }
  .mcluster-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mcluster-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mcluster-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mcluster-introduce-td{
    height: 45px;
  }
  .mcluster-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  @media screen and (max-width:482px) {
    .pwmat-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }

</style>
